<template>
  <div v-if="visible" :class="`d-flex align-items-center justify-content-center alert ${alertClass} ${{ mobile: isMobile }}`" role="alert">
    <img class="icon-danger align-self-center" src="@/assets/img/icons/information-circle.svg"></img>
    {{ message }} <a @click="openUrl()">{{ link.text }}</a>
  </div>
</template>

<script>
import { EventBus } from "@/main.js";


export default {
  name: 'Topbar',
  props: {
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      type: "info",
      message: "",
      link: {
        text: "",
        url: "",
      },
      serviceTopbar: null,
    };
  },
  computed: {
    alertClass() {
      return {
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      }[this.type] || 'alert-primary';
    }
  },
  async created() {
    EventBus.$on("showTopbar", data => {
      this.visible = true;
      this.type = data.type;
      this.message = data.message;
      let linkParts = data.link.split('|');
      this.link.text = linkParts[0];
      this.link.url = linkParts[1];
    });
    await this.$store.dispatch("getTopbarMessage").then((topbarData) => {
      if (topbarData.visible) {
        this.visible = topbarData.visible;
        this.type = topbarData.type;
        this.message = topbarData.message;
        let linkParts = topbarData.link.split('|');
        this.link.text = linkParts[0];
        this.link.url = linkParts[1];
      }
    });
  },
  methods:{
    openUrl(){
      if (this.$route.path !== this.link.url) {
          this.$router.push(this.link.url);
      }
    }
  }
};
</script>

<style scoped>
a {
  font-weight: 600;
  cursor: pointer;
}
.alert {
  top: 0;
  z-index: 800;
  text-align: center;
  border-radius: 0px;
  gap: 1rem;
}
.alert.mobile {
  margin-left: -17px;
}
</style>